
// This defines all overridden components.
//
// Copyright (C) 2025 Northwestern University
//
// Prism is all rights reserved.

import { ItemOfCommunityRecordSearch, ItemOfDashboardRecordSearch, ItemOfGlobalRecordSearch } from "./ItemOfSearchResults";
import { PIDFields } from "./PidFields";
import { PublishModalComponent, SubmitReviewModalComponent } from "./PublicationModals";

/**
 * Overridden Components
 */
export const overriddenComponents = {
  "InvenioAppRdm.Deposit.PIDField.container": PIDFields,
  // Remove statistics - START
  "InvenioAppRdm.Search.RecordsResultsListItem.layout": ItemOfGlobalRecordSearch,
  "InvenioCommunities.DetailsSearch.RecordsResultsListItem.layout": ItemOfCommunityRecordSearch,
  "InvenioAppRdm.DashboardUploads.ResultsList.item": ItemOfDashboardRecordSearch,
  // Remove statistics - END
  // Remove Copyright field
  "InvenioAppRdm.Deposit.CopyrightsField.container": () => null,
  // Custom publication modal(s)
  "InvenioRdmRecords.PublishModal.container": PublishModalComponent,
  "InvenioRdmRecords.SubmitReviewModal.container": SubmitReviewModalComponent,
  // Remove Add Award button
  "InvenioVocabularies.FundingField.AddAwardFundingModal.Container": () => null,
};
